const tickWrap = cb => {
  return setTimeout(() => {
    return cb()
  }, 0)
}

export default tickWrap
